import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import WhyChooseUs from "@/customComponents/sharedComponents/WhyChooseUs.jsx";
import {MODAL_STEPS} from "@/constants/steps";

// Mobile step for "More Than A Ride. Why Choose us?" (desktop renders it inline as
// the 'more' view of the compare .upper-modal). Reuses the same WhyChooseUs
// component; perk taps route to the existing standalone steps on mobile.
const PERK_STEPS = {
    afterpay: MODAL_STEPS.INTEREST_FREE_PAYMENT,
    flight: MODAL_STEPS.FLIGHT_DELAYED,
    payafter: MODAL_STEPS.PAY_AFTER_DROPOFF,
    cancellation: MODAL_STEPS.CANCELLATION_MODIFICATION_REFUND,
};

export function WhyChooseUsStep(props) {
    const goToPerk = (action) => {
        const step = PERK_STEPS[action];
        if (!step) return;
        // Back target is auto-captured by the banner (previous = this step).
        props.setStep(step);
    };

    return (
        <>
            <ModalHeader
                title=""
                extraClasses="less-space"
                totalSteps={0}
                cancelButton={false}
                backStep={props.previousStep || MODAL_STEPS.PREBOOK_COMPARE}
                showBackButton={true}
                setStep={props.setStep}
                closeModal={props.closeModal}
            />

            <div className="modalPages-spacing padding-bottom-30">
                <WhyChooseUs onPerkAction={goToPerk}/>
            </div>
        </>
    );
}

export default WhyChooseUsStep;
